import React, { useState, useEffect, useCallback } from 'react';

const API = 'https://api.botanix.in/api/hr';

const C = {
  accent:'#3AAF58', accentLight:'#EAF7EE', accentDark:'#2E8B47',
  bg:'#F3F6F3', surface:'#FFFFFF',
  border:'#E2E8E2', border2:'#CDD8CD',
  text:'#1A2E1E', text2:'#3D5E44', text3:'#7A9A80',
  amber:'#D4840F', amberBg:'#FEF6E7', amberBorder:'#F0D499',
  red:'#C83333', redBg:'#FDEAEA', redBorder:'#F0B8B8',
  blue:'#2563A8', blueBg:'#EAF1FB', blueBorder:'#B8D0F0',
  purple:'#6B48A8', purpleBg:'#F0EBFB', purpleBorder:'#C8B8F0',
  teal:'#1A7A7A', tealBg:'#E7F5F5', tealBorder:'#A8D8D8',
};

const inr = n => 'Rs.' + Number(n||0).toLocaleString('en-IN', { maximumFractionDigits:0 });
const today = () => new Date().toISOString().slice(0,10);
const currMonth = () => new Date().getMonth() + 1;
const currYear = () => new Date().getFullYear();

const Card = ({ children, style={} }) => (
  <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, boxShadow:'0 1px 4px rgba(0,0,0,.05)', ...style }}>{children}</div>
);

const Btn = ({ children, onClick, variant='primary', style={}, disabled }) => {
  const v = {
    primary:{ background:C.accent, color:'#fff', border:'none' },
    danger: { background:C.red, color:'#fff', border:'none' },
    ghost:  { background:'transparent', color:C.text2, border:`1px solid ${C.border2}` },
    light:  { background:C.accentLight, color:C.accent, border:'none' },
    amber:  { background:C.amberBg, color:C.amber, border:`1px solid ${C.amberBorder}` },
  };
  return <button onClick={onClick} disabled={disabled}
    style={{ ...v[variant], padding:'8px 16px', borderRadius:8, fontSize:13, fontWeight:600,
      cursor:disabled?'not-allowed':'pointer', opacity:disabled?0.5:1,
      display:'inline-flex', alignItems:'center', gap:6, whiteSpace:'nowrap', ...style }}>{children}</button>;
};

const Inp = ({ label, value, onChange, type='text', opts, placeholder='' }) => {
  const base = { width:'100%', padding:'9px 12px', background:C.bg, border:`1px solid ${C.border2}`, borderRadius:8, color:C.text, fontSize:13, boxSizing:'border-box' };
  return (
    <div style={{ marginBottom:12 }}>
      {label && <div style={{ fontSize:11, fontWeight:700, color:C.text3, textTransform:'uppercase', letterSpacing:'.05em', marginBottom:5 }}>{label}</div>}
      {opts
        ? <select style={base} value={value} onChange={e=>onChange(e.target.value)}>
            {opts.map(o=><option key={o.value||o} value={o.value||o}>{o.label||o}</option>)}
          </select>
        : <input type={type} style={base} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} />}
    </div>
  );
};

const Modal = ({ title, onClose, children, width='520px' }) => (
  <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.45)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
    <Card style={{ width, maxWidth:'100%', maxHeight:'90vh', overflow:'auto', padding:28 }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <div style={{ fontSize:17, fontWeight:800, color:C.text }}>{title}</div>
        <button onClick={onClose} style={{ background:C.bg, border:`1px solid ${C.border}`, borderRadius:8, width:32, height:32, cursor:'pointer', color:C.text2 }}>X</button>
      </div>
      {children}
    </Card>
  </div>
);

const Th = ({ c }) => <th style={{ padding:'10px 14px', fontSize:11, fontWeight:700, color:C.text3, textTransform:'uppercase', letterSpacing:'.06em', textAlign:'left', background:'#F5F8F5', borderBottom:`1px solid ${C.border}`, whiteSpace:'nowrap' }}>{c}</th>;
const Td = ({ children, style={} }) => <td style={{ padding:'11px 14px', fontSize:13, borderBottom:`1px solid ${C.border}`, verticalAlign:'middle', ...style }}>{children}</td>;
const Empty = ({ msg }) => <div style={{ padding:'40px 20px', textAlign:'center', color:C.text3, fontSize:14 }}>{msg}</div>;
const Stat = ({ label, value, sub, color=C.accent, bg=C.accentLight, onClick }) => (
  <Card onClick={onClick} style={{ padding:18, cursor:onClick?'pointer':'default' }}>
    <div style={{ fontSize:11, fontWeight:700, color:C.text3, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:8 }}>{label}</div>
    <div style={{ fontSize:24, fontWeight:800, color, letterSpacing:'-.02em' }}>{value}</div>
    {sub && <div style={{ fontSize:12, color:C.text3, marginTop:3 }}>{sub}</div>}
  </Card>
);

const statusBadge = (s) => {
  const map = {
    active:[C.accent,C.accentLight,'#A8D8B8'], inactive:[C.text3,C.border,C.border2],
    present:[C.accent,C.accentLight,'#A8D8B8'], absent:[C.red,C.redBg,C.redBorder],
    leave:[C.blue,C.blueBg,C.blueBorder], half_day:[C.amber,C.amberBg,C.amberBorder],
    approved:[C.accent,C.accentLight,'#A8D8B8'], pending:[C.amber,C.amberBg,C.amberBorder],
    rejected:[C.red,C.redBg,C.redBorder], paid:[C.accent,C.accentLight,'#A8D8B8'],
    monthly:[C.blue,C.blueBg,C.blueBorder], daily:[C.purple,C.purpleBg,C.purpleBorder],
  };
  const [col,bg,brd] = map[s] || [C.text3,C.border,C.border2];
  return <span style={{ display:'inline-flex', alignItems:'center', gap:4, padding:'2px 10px', borderRadius:99, fontSize:11, fontWeight:600, color:col, background:bg, border:`1px solid ${brd}` }}>
    <span style={{ width:5, height:5, borderRadius:'50%', background:col }} />{s}
  </span>;
};

// ── DASHBOARD ──────────────────────────────────────────────────────────────
function Dashboard({ setTab }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${API}/dashboard`).then(r=>r.json()).then(setData).catch(()=>{});
  }, []);

  const totalEmp = (data?.employees||[]).find(e=>e.status==='active');
  const todayPresent = (data?.attendance||[]).find(a=>a.status==='present');
  const todayAbsent = (data?.attendance||[]).find(a=>a.status==='absent');
  const pendingPayroll = (data?.payroll||[]).find(p=>p.payment_status==='pending');

  return (
    <div style={{ padding:'24px 28px' }}>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(150px,1fr))', gap:12, marginBottom:22 }}>
        <Stat label="Total Staff" value={totalEmp?.count||0} sub="Active employees" onClick={()=>setTab('employees')} />
        <Stat label="Present Today" value={todayPresent?.count||0} sub="Checked in" color={C.accent} onClick={()=>setTab('attendance')} />
        <Stat label="Absent Today" value={todayAbsent?.count||0} sub="Not present" color={C.red} bg={C.redBg} onClick={()=>setTab('attendance')} />
        <Stat label="Pending Leaves" value={data?.pending_leaves||0} sub="Awaiting approval" color={C.amber} bg={C.amberBg} onClick={()=>setTab('leaves')} />
        <Stat label="Payroll Pending" value={pendingPayroll?.count||0} sub="This month" color={C.purple} bg={C.purpleBg} onClick={()=>setTab('payroll')} />
        <Stat label="Payroll Amount" value={inr(pendingPayroll?.total||0)} sub="To be paid" color={C.blue} bg={C.blueBg} onClick={()=>setTab('payroll')} />
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
        <Card style={{ padding:20 }}>
          <div style={{ fontSize:15, fontWeight:800, color:C.text, marginBottom:14 }}>Staff by Department</div>
          {(data?.departments||[]).filter(d=>parseInt(d.count)>0).map(d => (
            <div key={d.name} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
              <span style={{ fontSize:13, color:C.text }}>{d.name}</span>
              <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                <div style={{ width:80, height:5, background:C.border, borderRadius:99 }}>
                  <div style={{ height:5, width:`${Math.min((parseInt(d.count)/Math.max(parseInt((data?.departments||[]).reduce((m,x)=>Math.max(m,parseInt(x.count||0)),0)),1))*100,100)}%`, background:C.accent, borderRadius:99 }} />
                </div>
                <span style={{ fontSize:13, fontWeight:700, color:C.accent, minWidth:20 }}>{d.count}</span>
              </div>
            </div>
          ))}
        </Card>

        <Card style={{ padding:20, background:'linear-gradient(135deg,#0A1A0F,#0F2A14)', border:'none' }}>
          <div style={{ fontSize:13, fontWeight:700, color:C.accent, marginBottom:12, textTransform:'uppercase', letterSpacing:'.08em' }}>HR Insights</div>
          {[
            ['Attendance Rate', `${Math.round(((parseInt(todayPresent?.count||0))/(Math.max(parseInt(totalEmp?.count||1),1)))*100)}% staff present today`],
            ['Leave Pipeline', `${data?.pending_leaves||0} leave requests awaiting approval`],
            ['Payroll Status', `${pendingPayroll?.count||0} employees pending salary this month`],
            ['Quick Action', 'Generate payroll and mark bulk attendance from respective tabs'],
          ].map(([t,d]) => (
            <div key={t} style={{ padding:'10px 12px', background:'rgba(58,175,88,.08)', borderRadius:8, marginBottom:8, border:'1px solid rgba(58,175,88,.15)' }}>
              <div style={{ fontSize:11, fontWeight:700, color:C.accent, marginBottom:3 }}>{t}</div>
              <div style={{ fontSize:12, color:'rgba(240,248,242,.7)' }}>{d}</div>
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
}

// ── EMPLOYEES ──────────────────────────────────────────────────────────────
function EmployeesTab({ departments }) {
  const [employees, setEmployees] = useState([]);
  const [search, setSearch] = useState('');
  const [filterDept, setFilterDept] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [viewEmp, setViewEmp] = useState(null);
  const [pinModal, setPinModal] = useState(null);
  const [newPin, setNewPin] = useState('');
  const [pinMsg, setPinMsg] = useState('');

  const setPin = async (empId) => {
    if (newPin.length !== 6 || isNaN(newPin)) { setPinMsg('PIN must be exactly 6 digits'); return; }
    const res = await fetch(`${API}/employees/${empId}/set-pin`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ pin: newPin }) });
    if (res.ok) { setPinMsg('PIN set successfully!'); setNewPin(''); setTimeout(()=>{ setPinModal(null); setPinMsg(''); }, 1500); }
    else setPinMsg('Failed to set PIN');
  };

  const [form, setForm] = useState({
    name:'', department_id:'', designation:'', employment_type:'full_time',
    salary_type:'monthly', basic_salary:'', hra:'', allowances:'', daily_wage:'',
    phone:'', email:'', address:'', aadhar:'', pan:'',
    bank_account:'', bank_ifsc:'', bank_name:'',
    date_of_joining:today(), date_of_birth:'', gender:'male', blood_group:'', emergency_contact:''
  });
  const f = k => v => setForm(p=>({...p,[k]:v}));

  const load = useCallback(() => {
    let url = `${API}/employees?`;
    if (filterDept) url += `department_id=${filterDept}&`;
    if (search) url += `search=${search}`;
    fetch(url).then(r=>r.json()).then(d=>setEmployees(Array.isArray(d)?d:[])).catch(()=>{});
  }, [filterDept, search]);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    await fetch(`${API}/employees`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(form) });
    setShowModal(false); load();
  };

  return (
    <div style={{ padding:'24px 28px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <div style={{ fontSize:20, fontWeight:800, color:C.text }}>Employees ({employees.length})</div>
        <div style={{ display:'flex', gap:10 }}>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search name, code..."
            style={{ padding:'7px 12px', background:C.surface, border:`1px solid ${C.border2}`, borderRadius:8, color:C.text, fontSize:13, width:180 }} />
          <select value={filterDept} onChange={e=>setFilterDept(e.target.value)}
            style={{ padding:'7px 12px', background:C.surface, border:`1px solid ${C.border2}`, borderRadius:8, color:C.text, fontSize:13 }}>
            <option value="">All Departments</option>
            {departments.map(d=><option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
          <Btn onClick={()=>setShowModal(true)}>+ Add Employee</Btn>
        </div>
      </div>

      <Card>
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead><tr><Th c="Code" /><Th c="Name" /><Th c="Department" /><Th c="Designation" /><Th c="Type" /><Th c="Salary" /><Th c="Phone" /><Th c="Joined" /><Th c="Status" /><Th c="Action" /></tr></thead>
            <tbody>
              {employees.length===0 ? <tr><td colSpan={10}><Empty msg="No employees found" /></td></tr>
                : employees.map(e => (
                  <tr key={e.id}>
                    <Td><span style={{ fontFamily:'monospace', fontSize:11, background:C.bg, padding:'2px 7px', borderRadius:5, color:C.text3 }}>{e.emp_code}</span></Td>
                    <Td><div style={{ fontWeight:700 }}>{e.name}</div>{e.gender&&<div style={{ fontSize:11, color:C.text3 }}>{e.gender}</div>}</Td>
                    <Td style={{ color:C.text3 }}>{e.department_name||'-'}</Td>
                    <Td style={{ color:C.text2 }}>{e.designation||'-'}</Td>
                    <Td>{statusBadge(e.salary_type)}</Td>
                    <Td><span style={{ fontWeight:600 }}>{e.salary_type==='monthly'?inr(e.basic_salary):inr(e.daily_wage)+'/day'}</span></Td>
                    <Td style={{ color:C.text3 }}>{e.phone||'-'}</Td>
                    <Td style={{ fontSize:12, color:C.text3 }}>{e.date_of_joining?.slice(0,10)||'-'}</Td>
                    <Td>{statusBadge(e.status)}</Td>
                    <Td><Btn variant="light" onClick={()=>setViewEmp(e)} style={{ padding:'4px 12px', fontSize:12 }}>View</Btn></Td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </Card>

      {showModal && (
        <Modal title="Add Employee" onClose={()=>setShowModal(false)} width="620px">
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <Inp label="Full Name" value={form.name} onChange={f('name')} placeholder="Employee full name" />
            <Inp label="Department" value={form.department_id} onChange={f('department_id')} opts={[{value:'',label:'Select dept'},...departments.map(d=>({value:d.id,label:d.name}))]} />
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <Inp label="Designation" value={form.designation} onChange={f('designation')} placeholder="e.g. Housekeeper" />
            <Inp label="Employment Type" value={form.employment_type} onChange={f('employment_type')} opts={['full_time','part_time','contract','daily_wage','probation']} />
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <Inp label="Salary Type" value={form.salary_type} onChange={f('salary_type')} opts={['monthly','daily']} />
            <Inp label="Gender" value={form.gender} onChange={f('gender')} opts={['male','female','other']} />
          </div>
          {form.salary_type==='monthly' ? (
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 }}>
              <Inp label="Basic Salary (Rs)" value={form.basic_salary} onChange={f('basic_salary')} type="number" />
              <Inp label="HRA (Rs)" value={form.hra} onChange={f('hra')} type="number" />
              <Inp label="Allowances (Rs)" value={form.allowances} onChange={f('allowances')} type="number" />
            </div>
          ) : (
            <Inp label="Daily Wage (Rs)" value={form.daily_wage} onChange={f('daily_wage')} type="number" />
          )}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <Inp label="Phone" value={form.phone} onChange={f('phone')} placeholder="Mobile number" />
            <Inp label="Emergency Contact" value={form.emergency_contact} onChange={f('emergency_contact')} placeholder="Emergency mobile" />
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <Inp label="Date of Joining" value={form.date_of_joining} onChange={f('date_of_joining')} type="date" />
            <Inp label="Date of Birth" value={form.date_of_birth} onChange={f('date_of_birth')} type="date" />
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <Inp label="Aadhar Number" value={form.aadhar} onChange={f('aadhar')} placeholder="12-digit Aadhar" />
            <Inp label="PAN Number" value={form.pan} onChange={f('pan')} placeholder="PAN card" />
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 }}>
            <Inp label="Bank Account" value={form.bank_account} onChange={f('bank_account')} placeholder="Account number" />
            <Inp label="IFSC Code" value={form.bank_ifsc} onChange={f('bank_ifsc')} placeholder="IFSC" />
            <Inp label="Bank Name" value={form.bank_name} onChange={f('bank_name')} placeholder="Bank name" />
          </div>
          <Inp label="Address" value={form.address} onChange={f('address')} placeholder="Full address" />
          <div style={{ display:'flex', gap:10 }}>
            <Btn onClick={save} style={{ flex:1, justifyContent:'center' }}>Save Employee</Btn>
            <Btn variant="ghost" onClick={()=>setShowModal(false)} style={{ flex:1, justifyContent:'center' }}>Cancel</Btn>
          </div>
        </Modal>
      )}

      {viewEmp && (
        <Modal title={viewEmp.name} onClose={()=>setViewEmp(null)} width="600px">
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:16 }}>
            {[['Code',viewEmp.emp_code],['Department',viewEmp.department_name],['Designation',viewEmp.designation],['Type',viewEmp.employment_type],['Salary',viewEmp.salary_type==='monthly'?inr(viewEmp.basic_salary):inr(viewEmp.daily_wage)+'/day'],['Phone',viewEmp.phone||'-'],['Joined',viewEmp.date_of_joining?.slice(0,10)],['Blood Group',viewEmp.blood_group||'-'],['Aadhar',viewEmp.aadhar||'-'],['PAN',viewEmp.pan||'-'],['Bank',viewEmp.bank_name||'-'],['Account',viewEmp.bank_account||'-']].map(([l,v]) => (
              <div key={l} style={{ background:C.bg, borderRadius:8, padding:'8px 12px' }}>
                <div style={{ fontSize:10, color:C.text3 }}>{l}</div>
                <div style={{ fontSize:13, fontWeight:600, color:C.text, marginTop:2 }}>{v||'-'}</div>
              </div>
            ))}
          </div>
          <div style={{ display:'flex', gap:10, marginTop:8 }}>
            <Btn onClick={()=>{ setPinModal(viewEmp); setViewEmp(null); setNewPin(''); setPinMsg(''); }}
              variant="amber" style={{ flex:1, justifyContent:'center' }}>
              Set Attendance PIN
            </Btn>
            <Btn variant="ghost" onClick={()=>setViewEmp(null)} style={{ flex:1, justifyContent:'center' }}>Close</Btn>
          </div>
        </Modal>
      )}

      {pinModal && (
        <Modal title={`Set PIN - ${pinModal.name}`} onClose={()=>{ setPinModal(null); setPinMsg(''); }} width="380px">
          <div style={{ padding:'12px 14px', background:C.bg, borderRadius:8, marginBottom:14 }}>
            <div style={{ fontSize:12, color:C.text3 }}>Employee Code: <strong>{pinModal.emp_code}</strong></div>
            <div style={{ fontSize:12, color:C.text3, marginTop:4 }}>Staff will use this code + PIN to check in/out at the kiosk.</div>
          </div>
          <div style={{ marginBottom:12 }}>
            <div style={{ fontSize:11, fontWeight:700, color:C.text3, textTransform:'uppercase', letterSpacing:'.05em', marginBottom:5 }}>New 6-Digit PIN</div>
            <input
              type="password" maxLength={6}
              value={newPin} onChange={e=>setNewPin(e.target.value.replace(/\D/g,'').slice(0,6))}
              placeholder="Enter 6-digit PIN"
              style={{ width:'100%', padding:'12px 14px', background:C.bg, border:`1px solid ${C.border2}`, borderRadius:8, color:C.text, fontSize:18, letterSpacing:8, textAlign:'center', boxSizing:'border-box' }}
            />
          </div>
          {pinMsg && (
            <div style={{ padding:'10px 14px', borderRadius:8, marginBottom:12, fontSize:13, fontWeight:600,
              background: pinMsg.includes('success') ? C.accentLight : C.redBg,
              color: pinMsg.includes('success') ? C.accent : C.red }}>
              {pinMsg}
            </div>
          )}
          <div style={{ display:'flex', gap:10 }}>
            <Btn onClick={()=>setPin(pinModal.id)} style={{ flex:1, justifyContent:'center' }} disabled={newPin.length!==6}>
              Set PIN
            </Btn>
            <Btn variant="ghost" onClick={()=>{ setPinModal(null); setPinMsg(''); }} style={{ flex:1, justifyContent:'center' }}>Cancel</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── ATTENDANCE ─────────────────────────────────────────────────────────────
function AttendanceTab({ departments }) {
  const [employees, setEmployees] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [filterDate, setFilterDate] = useState(today());
  const [filterDept, setFilterDept] = useState('');
  const [bulkMode, setBulkMode] = useState(false);
  const [bulkData, setBulkData] = useState({});
  const [saving, setSaving] = useState(false);
  const [stats, setStats] = useState(null);

  const load = useCallback(() => {
    fetch(`${API}/employees?status=active${filterDept?`&department_id=${filterDept}`:''}`).then(r=>r.json()).then(d=>setEmployees(Array.isArray(d)?d:[])).catch(()=>{});
    fetch(`${API}/attendance?date=${filterDate}${filterDept?`&department_id=${filterDept}`:''}`).then(r=>r.json()).then(d=>setAttendance(Array.isArray(d)?d:[])).catch(()=>{});
    fetch(`${API}/attendance/stats`).then(r=>r.json()).then(setStats).catch(()=>{});
  }, [filterDate, filterDept]);
  useEffect(() => { load(); }, [load]);

  const getStatus = (empId) => {
    const a = attendance.find(a=>a.employee_id===empId);
    return a?.status || null;
  };

  const saveBulk = async () => {
    setSaving(true);
    const records = employees.map(e => ({
      employee_id: e.id,
      status: bulkData[e.id] || 'absent',
      check_in: bulkData[`${e.id}_in`] || null,
      check_out: bulkData[`${e.id}_out`] || null,
    }));
    await fetch(`${API}/attendance/bulk`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ date:filterDate, records }) });
    setSaving(false); setBulkMode(false); load();
  };

  const todayPresent = (stats?.today||[]).find(t=>t.status==='present')?.count||0;
  const todayAbsent = (stats?.today||[]).find(t=>t.status==='absent')?.count||0;

  return (
    <div style={{ padding:'24px 28px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <div style={{ fontSize:20, fontWeight:800, color:C.text }}>Attendance Management</div>
        <div style={{ display:'flex', gap:10, alignItems:'center' }}>
          <input type="date" value={filterDate} onChange={e=>setFilterDate(e.target.value)}
            style={{ padding:'7px 12px', background:C.surface, border:`1px solid ${C.border2}`, borderRadius:8, color:C.text, fontSize:13 }} />
          <select value={filterDept} onChange={e=>setFilterDept(e.target.value)}
            style={{ padding:'7px 12px', background:C.surface, border:`1px solid ${C.border2}`, borderRadius:8, color:C.text, fontSize:13 }}>
            <option value="">All Departments</option>
            {departments.map(d=><option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
          <Btn variant={bulkMode?'danger':'primary'} onClick={()=>setBulkMode(!bulkMode)}>
            {bulkMode ? 'Cancel Bulk' : 'Bulk Mark'}
          </Btn>
        </div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginBottom:18 }}>
        <Stat label="Total Staff" value={employees.length} sub="Active" />
        <Stat label="Present" value={todayPresent} sub="Today" color={C.accent} />
        <Stat label="Absent" value={todayAbsent} sub="Today" color={C.red} bg={C.redBg} />
        <Stat label="Not Marked" value={Math.max(0,employees.length-parseInt(todayPresent)-parseInt(todayAbsent))} sub="Pending" color={C.amber} bg={C.amberBg} />
      </div>

      {bulkMode && (
        <Card style={{ padding:20, marginBottom:16 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
            <div style={{ fontSize:15, fontWeight:800, color:C.text }}>Bulk Attendance - {filterDate}</div>
            <div style={{ display:'flex', gap:8 }}>
              <Btn variant="ghost" onClick={()=>{const d={}; employees.forEach(e=>{d[e.id]='present';}); setBulkData(d);}} style={{ padding:'5px 12px', fontSize:12 }}>All Present</Btn>
              <Btn variant="ghost" onClick={()=>{const d={}; employees.forEach(e=>{d[e.id]='absent';}); setBulkData(d);}} style={{ padding:'5px 12px', fontSize:12 }}>All Absent</Btn>
              <Btn onClick={saveBulk} disabled={saving} style={{ padding:'5px 16px', fontSize:12 }}>{saving?'Saving...':'Save All'}</Btn>
            </div>
          </div>
          <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead><tr><Th c="Employee" /><Th c="Department" /><Th c="Status" /><Th c="Check In" /><Th c="Check Out" /></tr></thead>
              <tbody>
                {employees.map(e => (
                  <tr key={e.id}>
                    <Td><div style={{ fontWeight:600 }}>{e.name}</div><div style={{ fontSize:11, color:C.text3 }}>{e.emp_code}</div></Td>
                    <Td style={{ color:C.text3 }}>{e.department_name}</Td>
                    <Td>
                      <select value={bulkData[e.id]||getStatus(e.id)||'present'} onChange={ev=>{const d={...bulkData};d[e.id]=ev.target.value;setBulkData(d);}}
                        style={{ padding:'5px 10px', background:C.bg, border:`1px solid ${C.border2}`, borderRadius:7, color:C.text, fontSize:12 }}>
                        {['present','absent','leave','half_day'].map(s=><option key={s}>{s}</option>)}
                      </select>
                    </Td>
                    <Td>
                      <input type="time" value={bulkData[`${e.id}_in`]||''} onChange={ev=>{const d={...bulkData};d[`${e.id}_in`]=ev.target.value;setBulkData(d);}}
                        style={{ padding:'4px 8px', background:C.bg, border:`1px solid ${C.border2}`, borderRadius:6, color:C.text, fontSize:12 }} />
                    </Td>
                    <Td>
                      <input type="time" value={bulkData[`${e.id}_out`]||''} onChange={ev=>{const d={...bulkData};d[`${e.id}_out`]=ev.target.value;setBulkData(d);}}
                        style={{ padding:'4px 8px', background:C.bg, border:`1px solid ${C.border2}`, borderRadius:6, color:C.text, fontSize:12 }} />
                    </Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}

      <Card>
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead><tr><Th c="Employee" /><Th c="Department" /><Th c="Status" /><Th c="Check In" /><Th c="Check Out" /><Th c="Hours" /><Th c="OT" /><Th c="Late" /></tr></thead>
            <tbody>
              {attendance.length===0 ? <tr><td colSpan={8}><Empty msg="No attendance marked for this date" /></td></tr>
                : attendance.map(a => (
                  <tr key={a.id}>
                    <Td><div style={{ fontWeight:600 }}>{a.employee_name}</div><div style={{ fontSize:11, color:C.text3 }}>{a.emp_code}</div></Td>
                    <Td style={{ color:C.text3 }}>{a.department_name||'-'}</Td>
                    <Td>{statusBadge(a.status)}</Td>
                    <Td style={{ color:C.text3 }}>{a.check_in||'-'}</Td>
                    <Td style={{ color:C.text3 }}>{a.check_out||'-'}</Td>
                    <Td><span style={{ fontWeight:600, color:C.accent }}>{a.working_hours?`${parseFloat(a.working_hours).toFixed(1)}h`:'-'}</span></Td>
                    <Td style={{ color:parseFloat(a.overtime_hours||0)>0?C.amber:C.text3 }}>{parseFloat(a.overtime_hours||0)>0?`${parseFloat(a.overtime_hours).toFixed(1)}h`:'-'}</Td>
                    <Td style={{ color:parseInt(a.late_minutes||0)>0?C.red:C.text3, fontWeight:parseInt(a.late_minutes||0)>0?700:400 }}>{parseInt(a.late_minutes||0)>0?`${a.late_minutes}m`:'-'}</Td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}

// ── LEAVES ─────────────────────────────────────────────────────────────────
function LeavesTab({ departments }) {
  const [leaves, setLeaves] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [filterStatus, setFilterStatus] = useState('pending');
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ employee_id:'', leave_type:'casual', from_date:today(), to_date:today(), reason:'' });
  const f = k => v => setForm(p=>({...p,[k]:v}));

  const load = useCallback(() => {
    fetch(`${API}/leaves?status=${filterStatus}`).then(r=>r.json()).then(d=>setLeaves(Array.isArray(d)?d:[])).catch(()=>{});
    fetch(`${API}/employees?status=active`).then(r=>r.json()).then(d=>setEmployees(Array.isArray(d)?d:[])).catch(()=>{});
  }, [filterStatus]);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    await fetch(`${API}/leaves`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(form) });
    setShowModal(false); load();
  };

  const approve = async (id, action) => {
    await fetch(`${API}/leaves/${id}/approve`, { method:'PATCH', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ action, approved_by:'HR Manager' }) });
    load();
  };

  const days = Math.max(1, Math.ceil((new Date(form.to_date)-new Date(form.from_date))/86400000)+1);

  return (
    <div style={{ padding:'24px 28px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <div style={{ fontSize:20, fontWeight:800, color:C.text }}>Leave Management</div>
        <div style={{ display:'flex', gap:10 }}>
          {['pending','approved','rejected','all'].map(s => (
            <button key={s} onClick={()=>setFilterStatus(s)}
              style={{ padding:'6px 14px', borderRadius:8, border:`1px solid ${filterStatus===s?C.accent:C.border2}`,
                background:filterStatus===s?C.accentLight:'transparent', color:filterStatus===s?C.accent:C.text3,
                fontSize:12, fontWeight:600, cursor:'pointer' }}>
              {s.charAt(0).toUpperCase()+s.slice(1)}
            </button>
          ))}
          <Btn onClick={()=>setShowModal(true)}>+ Apply Leave</Btn>
        </div>
      </div>
      <Card>
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead><tr><Th c="Employee" /><Th c="Department" /><Th c="Leave Type" /><Th c="From" /><Th c="To" /><Th c="Days" /><Th c="Reason" /><Th c="Status" /><Th c="Action" /></tr></thead>
            <tbody>
              {leaves.length===0 ? <tr><td colSpan={9}><Empty msg="No leave requests" /></td></tr>
                : leaves.map(l => (
                  <tr key={l.id}>
                    <Td><div style={{ fontWeight:600 }}>{l.employee_name}</div><div style={{ fontSize:11, color:C.text3 }}>{l.emp_code}</div></Td>
                    <Td style={{ color:C.text3 }}>{l.department_name||'-'}</Td>
                    <Td><span style={{ fontSize:12, background:C.bg, padding:'2px 8px', borderRadius:6 }}>{l.leave_type}</span></Td>
                    <Td style={{ fontSize:12, color:C.text3 }}>{l.from_date?.slice(0,10)}</Td>
                    <Td style={{ fontSize:12, color:C.text3 }}>{l.to_date?.slice(0,10)}</Td>
                    <Td><span style={{ fontWeight:700, color:C.accent }}>{l.days}</span></Td>
                    <Td style={{ fontSize:12, color:C.text3, maxWidth:200 }}>{l.reason?.slice(0,60)}</Td>
                    <Td>{statusBadge(l.status)}</Td>
                    <Td>
                      {l.status==='pending' && (
                        <div style={{ display:'flex', gap:6 }}>
                          <Btn onClick={()=>approve(l.id,'approve')} variant="light" style={{ padding:'4px 10px', fontSize:11 }}>Approve</Btn>
                          <Btn onClick={()=>approve(l.id,'reject')} variant="danger" style={{ padding:'4px 10px', fontSize:11 }}>Reject</Btn>
                        </div>
                      )}
                    </Td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </Card>
      {showModal && (
        <Modal title="Apply Leave" onClose={()=>setShowModal(false)}>
          <Inp label="Employee" value={form.employee_id} onChange={f('employee_id')} opts={[{value:'',label:'Select employee'},...employees.map(e=>({value:e.id,label:`${e.name} (${e.emp_code})`}))]} />
          <Inp label="Leave Type" value={form.leave_type} onChange={f('leave_type')} opts={['casual','sick','earned','unpaid','maternity','paternity','emergency']} />
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <Inp label="From Date" value={form.from_date} onChange={f('from_date')} type="date" />
            <Inp label="To Date" value={form.to_date} onChange={f('to_date')} type="date" />
          </div>
          <div style={{ padding:'10px 14px', background:C.accentLight, borderRadius:8, marginBottom:12, fontSize:13, color:C.accent, fontWeight:600 }}>
            Duration: {days} day{days>1?'s':''}
          </div>
          <Inp label="Reason" value={form.reason} onChange={f('reason')} placeholder="Reason for leave..." />
          <div style={{ display:'flex', gap:10 }}>
            <Btn onClick={save} style={{ flex:1, justifyContent:'center' }}>Submit</Btn>
            <Btn variant="ghost" onClick={()=>setShowModal(false)} style={{ flex:1, justifyContent:'center' }}>Cancel</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── PAYROLL ────────────────────────────────────────────────────────────────
function PayrollTab() {
  const [payroll, setPayroll] = useState([]);
  const [month, setMonth] = useState(currMonth());
  const [year, setYear] = useState(currYear());
  const [generating, setGenerating] = useState(false);
  const [genResult, setGenResult] = useState(null);

  const load = useCallback(() => {
    fetch(`${API}/payroll?month=${month}&year=${year}`).then(r=>r.json()).then(d=>setPayroll(Array.isArray(d)?d:[])).catch(()=>{});
  }, [month, year]);
  useEffect(() => { load(); }, [load]);

  const generate = async () => {
    setGenerating(true); setGenResult(null);
    const res = await fetch(`${API}/payroll/generate`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ month, year }) });
    const data = await res.json();
    setGenResult(data); setGenerating(false); load();
  };

  const pay = async (id) => {
    await fetch(`${API}/payroll/${id}/pay`, { method:'PATCH', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ payment_mode:'bank_transfer' }) });
    load();
  };

  const totalGross = payroll.reduce((s,p)=>s+parseFloat(p.gross_salary||0),0);
  const totalNet = payroll.reduce((s,p)=>s+parseFloat(p.net_salary||0),0);
  const totalPF = payroll.reduce((s,p)=>s+parseFloat(p.pf_deduction||0),0);
  const paid = payroll.filter(p=>p.payment_status==='paid').length;

  return (
    <div style={{ padding:'24px 28px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <div style={{ fontSize:20, fontWeight:800, color:C.text }}>Payroll Management</div>
        <div style={{ display:'flex', gap:10, alignItems:'center' }}>
          <select value={month} onChange={e=>setMonth(parseInt(e.target.value))}
            style={{ padding:'7px 12px', background:C.surface, border:`1px solid ${C.border2}`, borderRadius:8, color:C.text, fontSize:13 }}>
            {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'].map((m,i)=><option key={i} value={i+1}>{m}</option>)}
          </select>
          <select value={year} onChange={e=>setYear(parseInt(e.target.value))}
            style={{ padding:'7px 12px', background:C.surface, border:`1px solid ${C.border2}`, borderRadius:8, color:C.text, fontSize:13 }}>
            {[2025,2026,2027].map(y=><option key={y}>{y}</option>)}
          </select>
          <Btn onClick={generate} disabled={generating} variant={payroll.length?'ghost':'primary'}>
            {generating ? 'Generating...' : payroll.length ? 'Regenerate' : 'Generate Payroll'}
          </Btn>
        </div>
      </div>

      {genResult && (
        <div style={{ background:C.accentLight, border:`1px solid ${C.accent}`, borderRadius:10, padding:'12px 16px', marginBottom:16, fontSize:13, color:C.accent, fontWeight:600 }}>
          Payroll generated for {genResult.generated} employees. Total payroll: {inr(genResult.total_payroll)}
        </div>
      )}

      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginBottom:18 }}>
        <Stat label="Total Employees" value={payroll.length} sub="In payroll" />
        <Stat label="Gross Payroll" value={inr(totalGross)} sub="Before deductions" color={C.blue} bg={C.blueBg} />
        <Stat label="Net Payroll" value={inr(totalNet)} sub="After PF/ESI" color={C.accent} />
        <Stat label="PF Contribution" value={inr(totalPF)} sub="Employer + employee" color={C.purple} bg={C.purpleBg} />
      </div>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
        <div style={{ fontSize:13, color:C.text3 }}>{paid} of {payroll.length} employees paid</div>
        {payroll.filter(p=>p.payment_status!=='paid').length > 0 && (
          <Btn variant="amber" onClick={async()=>{ for(const p of payroll.filter(x=>x.payment_status!=='paid')) await pay(p.id); load(); }}
            style={{ padding:'6px 16px', fontSize:12 }}>
            Pay All Pending ({inr(payroll.filter(p=>p.payment_status!=='paid').reduce((s,p)=>s+parseFloat(p.net_salary||0),0))})
          </Btn>
        )}
      </div>

      <Card>
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead><tr><Th c="Employee" /><Th c="Dept" /><Th c="Present" /><Th c="Absent" /><Th c="OT Hrs" /><Th c="Basic" /><Th c="OT Amt" /><Th c="Gross" /><Th c="PF" /><Th c="ESI" /><Th c="Net" /><Th c="Status" /><Th c="Action" /></tr></thead>
            <tbody>
              {payroll.length===0 ? <tr><td colSpan={13}><Empty msg="No payroll generated yet. Click Generate Payroll." /></td></tr>
                : payroll.map(p => (
                  <tr key={p.id}>
                    <Td><div style={{ fontWeight:600 }}>{p.employee_name}</div><div style={{ fontSize:11, color:C.text3 }}>{p.emp_code}</div></Td>
                    <Td style={{ fontSize:12, color:C.text3 }}>{p.department_name}</Td>
                    <Td style={{ color:C.accent, fontWeight:700 }}>{p.days_present}</Td>
                    <Td style={{ color:p.days_absent>0?C.red:C.text3 }}>{p.days_absent}</Td>
                    <Td style={{ color:parseFloat(p.overtime_hours||0)>0?C.amber:C.text3 }}>{parseFloat(p.overtime_hours||0).toFixed(1)}</Td>
                    <Td>{inr(p.basic_earned)}</Td>
                    <Td style={{ color:C.amber }}>{inr(p.overtime_amount)}</Td>
                    <Td><span style={{ fontWeight:700 }}>{inr(p.gross_salary)}</span></Td>
                    <Td style={{ color:C.red }}>{inr(p.pf_deduction)}</Td>
                    <Td style={{ color:C.red }}>{inr(p.esi_deduction)}</Td>
                    <Td><span style={{ fontWeight:800, color:C.accent }}>{inr(p.net_salary)}</span></Td>
                    <Td>{statusBadge(p.payment_status)}</Td>
                    <Td>{p.payment_status!=='paid' && <Btn onClick={()=>pay(p.id)} variant="light" style={{ padding:'4px 12px', fontSize:11 }}>Pay</Btn>}</Td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}

// ── PERFORMANCE ────────────────────────────────────────────────────────────
function PerformanceTab() {
  const [reviews, setReviews] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ employee_id:'', review_period:'Q1', year:currYear(), punctuality:3, quality_of_work:3, teamwork:3, attitude:3, productivity:3, comments:'', reviewed_by:'' });
  const f = k => v => setForm(p=>({...p,[k]:v}));

  useEffect(() => {
    fetch(`${API}/performance`).then(r=>r.json()).then(d=>setReviews(Array.isArray(d)?d:[])).catch(()=>{});
    fetch(`${API}/employees?status=active`).then(r=>r.json()).then(d=>setEmployees(Array.isArray(d)?d:[])).catch(()=>{});
  }, []);

  const save = async () => {
    await fetch(`${API}/performance`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(form) });
    setShowModal(false);
    fetch(`${API}/performance`).then(r=>r.json()).then(d=>setReviews(Array.isArray(d)?d:[]));
  };

  const ratingColor = r => parseFloat(r)>=4?C.accent:parseFloat(r)>=3?C.amber:C.red;

  return (
    <div style={{ padding:'24px 28px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <div style={{ fontSize:20, fontWeight:800, color:C.text }}>Performance Reviews</div>
        <Btn onClick={()=>setShowModal(true)}>+ Add Review</Btn>
      </div>
      {reviews.length===0 ? <Card style={{ padding:40, textAlign:'center', color:C.text3 }}>No performance reviews yet</Card> : (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))', gap:14 }}>
          {reviews.map(r => (
            <Card key={r.id} style={{ padding:20 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:12 }}>
                <div>
                  <div style={{ fontSize:15, fontWeight:800, color:C.text }}>{r.employee_name}</div>
                  <div style={{ fontSize:12, color:C.text3 }}>{r.department_name} - {r.review_period} {r.year}</div>
                </div>
                <div style={{ fontSize:28, fontWeight:800, color:ratingColor(r.overall_rating) }}>{r.overall_rating}</div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
                {[['Punctuality',r.punctuality],['Quality',r.quality_of_work],['Teamwork',r.teamwork],['Attitude',r.attitude],['Productivity',r.productivity]].map(([l,v]) => (
                  <div key={l} style={{ background:C.bg, borderRadius:7, padding:'7px 10px' }}>
                    <div style={{ fontSize:10, color:C.text3 }}>{l}</div>
                    <div style={{ display:'flex', gap:2, marginTop:4 }}>
                      {[1,2,3,4,5].map(s=><div key={s} style={{ width:10, height:10, borderRadius:'50%', background:s<=v?ratingColor(v):C.border }} />)}
                    </div>
                  </div>
                ))}
              </div>
              {r.comments && <div style={{ fontSize:12, color:C.text3, marginTop:10, fontStyle:'italic' }}>{r.comments}</div>}
              <div style={{ fontSize:11, color:C.text3, marginTop:8 }}>Reviewed by: {r.reviewed_by}</div>
            </Card>
          ))}
        </div>
      )}
      {showModal && (
        <Modal title="Add Performance Review" onClose={()=>setShowModal(false)} width="560px">
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <Inp label="Employee" value={form.employee_id} onChange={f('employee_id')} opts={[{value:'',label:'Select employee'},...employees.map(e=>({value:e.id,label:`${e.name} (${e.emp_code})`}))]} />
            <Inp label="Review Period" value={form.review_period} onChange={f('review_period')} opts={['Q1','Q2','Q3','Q4','Annual','Probation']} />
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <Inp label="Year" value={form.year} onChange={f('year')} type="number" />
            <Inp label="Reviewed By" value={form.reviewed_by} onChange={f('reviewed_by')} placeholder="Manager name" />
          </div>
          <div style={{ padding:'14px 16px', background:C.bg, borderRadius:10, marginBottom:12 }}>
            <div style={{ fontSize:12, fontWeight:700, color:C.text3, marginBottom:12, textTransform:'uppercase' }}>Rating (1-5 for each parameter)</div>
            {[['punctuality','Punctuality'],['quality_of_work','Quality of Work'],['teamwork','Teamwork'],['attitude','Attitude'],['productivity','Productivity']].map(([key,label]) => (
              <div key={key} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
                <span style={{ fontSize:13, color:C.text }}>{label}</span>
                <div style={{ display:'flex', gap:6 }}>
                  {[1,2,3,4,5].map(s => (
                    <button key={s} onClick={()=>f(key)(s)}
                      style={{ width:30, height:30, borderRadius:'50%', border:'none', cursor:'pointer',
                        background:s<=form[key]?C.accent:C.border, color:s<=form[key]?'#fff':C.text2, fontSize:13, fontWeight:700 }}>
                      {s}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <Inp label="Comments" value={form.comments} onChange={f('comments')} placeholder="Overall feedback and development areas..." />
          <div style={{ display:'flex', gap:10 }}>
            <Btn onClick={save} style={{ flex:1, justifyContent:'center' }}>Save Review</Btn>
            <Btn variant="ghost" onClick={()=>setShowModal(false)} style={{ flex:1, justifyContent:'center' }}>Cancel</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── ATTENDANCE KIOSK ───────────────────────────────────────────────────────
function KioskTab() {
  const [empCode, setEmpCode] = useState('');
  const [pin, setPin] = useState('');
  const [mode, setMode] = useState('checkin');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!empCode || !pin) return;
    setLoading(true); setResult(null);
    try {
      const endpoint = mode === 'checkin' ? 'checkin' : 'checkout';
      const res = await fetch(`${API}/attendance/${endpoint}`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ emp_code:empCode, pin }) });
      const data = await res.json();
      if (res.ok) {
        setResult({ success:true, employee:data.employee, attendance:data.attendance });
        setEmpCode(''); setPin('');
      } else {
        setResult({ success:false, error:data.error });
      }
    } catch(e) { setResult({ success:false, error:'Connection error' }); }
    setLoading(false);
    setTimeout(() => setResult(null), 4000);
  };

  return (
    <div style={{ padding:'24px 28px', display:'flex', justifyContent:'center' }}>
      <div style={{ width:'100%', maxWidth:420 }}>
        <Card style={{ padding:32 }}>
          <div style={{ textAlign:'center', marginBottom:24 }}>
            <div style={{ fontSize:22, fontWeight:800, color:C.text, marginBottom:6 }}>Staff Attendance Kiosk</div>
            <div style={{ fontSize:13, color:C.text3 }}>Enter your Employee Code and PIN</div>
          </div>

          <div style={{ display:'flex', gap:8, marginBottom:20 }}>
            {['checkin','checkout'].map(m => (
              <button key={m} onClick={()=>setMode(m)}
                style={{ flex:1, padding:'10px', borderRadius:10, border:`2px solid ${mode===m?C.accent:C.border2}`,
                  background:mode===m?C.accentLight:'transparent', color:mode===m?C.accent:C.text3,
                  fontSize:14, fontWeight:700, cursor:'pointer' }}>
                {m==='checkin'?'Check In':'Check Out'}
              </button>
            ))}
          </div>

          <Inp label="Employee Code" value={empCode} onChange={setEmpCode} placeholder="e.g. BTX-0001" />
          <Inp label="PIN" value={pin} onChange={setPin} type="password" placeholder="6-digit PIN" />

          <Btn onClick={submit} disabled={loading||!empCode||!pin}
            style={{ width:'100%', justifyContent:'center', padding:'12px', fontSize:15, marginTop:8 }}>
            {loading ? 'Processing...' : mode==='checkin'?'Check In':'Check Out'}
          </Btn>

          {result && (
            <div style={{ marginTop:16, padding:'16px', borderRadius:10,
              background:result.success?C.accentLight:C.redBg,
              border:`1px solid ${result.success?C.accent:C.red}` }}>
              {result.success ? (
                <>
                  <div style={{ fontSize:16, fontWeight:800, color:C.accent, marginBottom:4 }}>
                    {mode==='checkin'?'Checked In':'Checked Out'} Successfully!
                  </div>
                  <div style={{ fontSize:14, color:C.text }}>{result.employee?.name}</div>
                  <div style={{ fontSize:12, color:C.text3 }}>{result.employee?.emp_code} - {result.attendance?.check_in && `In: ${result.attendance.check_in}`} {result.attendance?.check_out && `| Out: ${result.attendance.check_out}`}</div>
                </>
              ) : (
                <div style={{ fontSize:14, fontWeight:700, color:C.red }}>{result.error}</div>
              )}
            </div>
          )}
        </Card>

        <Card style={{ padding:20, marginTop:16 }}>
          <div style={{ fontSize:13, fontWeight:700, color:C.text, marginBottom:8 }}>First time? Set your PIN</div>
          <div style={{ fontSize:12, color:C.text3, lineHeight:1.6 }}>
            Ask your HR manager to set your PIN from the Employees tab. Once set, use your Employee Code + PIN to check in and out daily.
          </div>
        </Card>
      </div>
    </div>
  );
}

// ── BULK IMPORT ────────────────────────────────────────────────────────────
function BulkImportTab({ departments }) {
  const [csvText, setCsvText] = useState('');
  const [preview, setPreview] = useState([]);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const TEMPLATE = `name,department,designation,employment_type,salary_type,basic_salary,hra,allowances,daily_wage,phone,gender,date_of_joining
Ramesh Kumar,Housekeeping,Housekeeper,full_time,monthly,12000,2000,1000,,9820001001,male,2026-01-15
Sunita Devi,Kitchen,Cook Helper,full_time,daily,,,,600,9820001003,female,2026-02-01
Ravi Singh,Security,Security Guard,contract,monthly,14000,1500,500,,9820001005,male,2025-06-01`;

  const parseCSV = (text) => {
    const lines = text.trim().split('\n');
    if (lines.length < 2) return [];
    const headers = lines[0].split(',').map(h=>h.trim());
    return lines.slice(1).map(line => {
      const vals = line.split(',').map(v=>v.trim());
      const obj = {};
      headers.forEach((h,i) => { obj[h] = vals[i] || ''; });
      return obj;
    }).filter(r=>r.name);
  };

  const handleTextChange = (text) => {
    setCsvText(text);
    setPreview(parseCSV(text));
    setResult(null);
  };

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => handleTextChange(ev.target.result);
    reader.readAsText(file);
  };

  const importAll = async () => {
    if (!preview.length) return;
    setLoading(true); setResult(null);
    try {
      const res = await fetch(`${API}/employees/bulk-import`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ employees: preview })
      });
      const data = await res.json();
      setResult(data);
      if (data.imported > 0) { setCsvText(''); setPreview([]); }
    } catch(e) { setResult({ error: 'Connection error' }); }
    setLoading(false);
  };

  return (
    <div style={{ padding:'24px 28px' }}>
      <div style={{ fontSize:20, fontWeight:800, color:C.text, marginBottom:8 }}>Bulk Employee Import</div>
      <div style={{ fontSize:13, color:C.text3, marginBottom:20 }}>Import multiple employees at once using CSV format.</div>

      {result && (
        <div style={{ padding:'14px 18px', borderRadius:10, marginBottom:16,
          background: result.error ? C.redBg : C.accentLight,
          border: `1px solid ${result.error ? C.redBorder : C.accent}` }}>
          {result.error
            ? <div style={{ color:C.red, fontWeight:700 }}>{result.error}</div>
            : <>
                <div style={{ fontSize:15, fontWeight:800, color:C.accent, marginBottom:4 }}>
                  Successfully imported {result.imported} employees!
                </div>
                {result.errors > 0 && (
                  <div style={{ fontSize:13, color:C.amber }}>
                    {result.errors} failed: {result.details?.errors?.map(e=>e.name).join(', ')}
                  </div>
                )}
              </>}
        </div>
      )}

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 }}>
        {/* Template */}
        <Card style={{ padding:20 }}>
          <div style={{ fontSize:14, fontWeight:700, color:C.text, marginBottom:12 }}>Step 1 — Download Template</div>
          <div style={{ fontSize:12, color:C.text3, marginBottom:12, lineHeight:1.6 }}>
            Copy the CSV template below into Excel or Google Sheets, fill in your staff data, then save as CSV.
          </div>
          <div style={{ background:C.bg, borderRadius:8, padding:'12px 14px', marginBottom:12, fontSize:11, fontFamily:'monospace', color:C.text2, lineHeight:1.8, overflowX:'auto', whiteSpace:'nowrap' }}>
            name,department,designation,employment_type,<br/>
            salary_type,basic_salary,hra,allowances,<br/>
            daily_wage,phone,gender,date_of_joining
          </div>
          <div style={{ fontSize:12, fontWeight:700, color:C.text, marginBottom:8 }}>Valid department names:</div>
          <div style={{ display:'flex', flexWrap:'wrap', gap:4 }}>
            {departments.map(d => (
              <span key={d.id} style={{ fontSize:11, background:C.accentLight, color:C.accent, padding:'2px 8px', borderRadius:99 }}>{d.name}</span>
            ))}
          </div>
        </Card>

        {/* Column guide */}
        <Card style={{ padding:20 }}>
          <div style={{ fontSize:14, fontWeight:700, color:C.text, marginBottom:12 }}>Column Values Guide</div>
          {[
            ['employment_type', 'full_time, part_time, contract, daily_wage, probation'],
            ['salary_type', 'monthly OR daily'],
            ['basic_salary', 'Monthly salary amount (if monthly type)'],
            ['hra', 'House Rent Allowance (if monthly)'],
            ['allowances', 'Other allowances (if monthly)'],
            ['daily_wage', 'Per day wage (if daily type)'],
            ['gender', 'male, female, other'],
            ['date_of_joining', 'YYYY-MM-DD format e.g. 2026-01-15'],
          ].map(([col, val]) => (
            <div key={col} style={{ display:'flex', gap:10, marginBottom:8, fontSize:12 }}>
              <span style={{ fontFamily:'monospace', color:C.accent, fontWeight:700, minWidth:120, flexShrink:0 }}>{col}</span>
              <span style={{ color:C.text3 }}>{val}</span>
            </div>
          ))}
        </Card>
      </div>

      {/* Upload area */}
      <Card style={{ padding:20, marginBottom:16 }}>
        <div style={{ fontSize:14, fontWeight:700, color:C.text, marginBottom:12 }}>Step 2 — Upload or Paste CSV</div>
        <div style={{ display:'flex', gap:12, marginBottom:14, alignItems:'center' }}>
          <label style={{ padding:'8px 16px', background:C.accentLight, color:C.accent, borderRadius:8, fontSize:13, fontWeight:600, cursor:'pointer', border:`1px solid ${C.accent}` }}>
            Upload CSV File
            <input type="file" accept=".csv,.txt" onChange={handleFile} style={{ display:'none' }} />
          </label>
          <span style={{ color:C.text3, fontSize:13 }}>or paste CSV text below</span>
          <Btn variant="ghost" onClick={()=>handleTextChange(TEMPLATE)} style={{ padding:'6px 14px', fontSize:12 }}>
            Load Sample
          </Btn>
        </div>
        <textarea
          value={csvText}
          onChange={e=>handleTextChange(e.target.value)}
          placeholder="Paste your CSV data here..."
          style={{ width:'100%', height:160, padding:'12px 14px', background:C.bg, border:`1px solid ${C.border2}`,
            borderRadius:8, color:C.text, fontSize:12, fontFamily:'monospace', resize:'vertical', boxSizing:'border-box' }}
        />
      </Card>

      {/* Preview */}
      {preview.length > 0 && (
        <Card style={{ marginBottom:16 }}>
          <div style={{ padding:'14px 18px', borderBottom:`1px solid ${C.border}`, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <div style={{ fontSize:14, fontWeight:700, color:C.text }}>Preview — {preview.length} employees ready to import</div>
            <Btn onClick={importAll} disabled={loading}>
              {loading ? 'Importing...' : `Import ${preview.length} Employees`}
            </Btn>
          </div>
          <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead><tr><Th c="#" /><Th c="Name" /><Th c="Department" /><Th c="Designation" /><Th c="Type" /><Th c="Salary" /><Th c="Phone" /><Th c="Gender" /></tr></thead>
              <tbody>
                {preview.slice(0,20).map((emp,i) => (
                  <tr key={i} style={{ background: !emp.name ? C.redBg : 'transparent' }}>
                    <Td style={{ color:C.text3, fontSize:11 }}>{i+1}</Td>
                    <Td><span style={{ fontWeight:600 }}>{emp.name||'MISSING'}</span></Td>
                    <Td style={{ color:C.text3 }}>{emp.department||'-'}</Td>
                    <Td style={{ color:C.text3 }}>{emp.designation||'-'}</Td>
                    <Td><span style={{ fontSize:11, background:C.bg, padding:'2px 7px', borderRadius:5 }}>{emp.salary_type||'monthly'}</span></Td>
                    <Td style={{ color:C.accent, fontWeight:600 }}>
                      {emp.salary_type==='daily' ? `Rs.${emp.daily_wage}/day` : `Rs.${emp.basic_salary}/mo`}
                    </Td>
                    <Td style={{ color:C.text3 }}>{emp.phone||'-'}</Td>
                    <Td style={{ color:C.text3 }}>{emp.gender||'-'}</Td>
                  </tr>
                ))}
                {preview.length > 20 && (
                  <tr><td colSpan={8} style={{ padding:'10px 14px', textAlign:'center', color:C.text3, fontSize:12 }}>...and {preview.length-20} more employees</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}

// ── DEPARTMENTS ────────────────────────────────────────────────────────────
function DepartmentsTab({ departments, reload }) {
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name:'', head:'', budget:'' });
  const f = k => v => setForm(p=>({...p,[k]:v}));

  const save = async () => {
    await fetch(`${API}/departments`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(form) });
    setShowModal(false); reload();
  };

  return (
    <div style={{ padding:'24px 28px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <div style={{ fontSize:20, fontWeight:800, color:C.text }}>Departments</div>
        <Btn onClick={()=>setShowModal(true)}>+ Add Department</Btn>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(220px,1fr))', gap:14 }}>
        {departments.map(d => (
          <Card key={d.id} style={{ padding:20 }}>
            <div style={{ fontSize:15, fontWeight:800, color:C.text, marginBottom:6 }}>{d.name}</div>
            <div style={{ fontSize:12, color:C.text3, marginBottom:10 }}>Head: {d.head||'Not assigned'}</div>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <div style={{ fontSize:22, fontWeight:800, color:C.accent }}>{d.employee_count||0}</div>
              <div style={{ fontSize:12, color:C.text3 }}>employees</div>
            </div>
          </Card>
        ))}
      </div>
      {showModal && (
        <Modal title="Add Department" onClose={()=>setShowModal(false)} width="400px">
          <Inp label="Department Name" value={form.name} onChange={f('name')} placeholder="e.g. Spa & Wellness" />
          <Inp label="Department Head" value={form.head} onChange={f('head')} placeholder="Manager name" />
          <Inp label="Budget (Rs)" value={form.budget} onChange={f('budget')} type="number" />
          <div style={{ display:'flex', gap:10 }}>
            <Btn onClick={save} style={{ flex:1, justifyContent:'center' }}>Save</Btn>
            <Btn variant="ghost" onClick={()=>setShowModal(false)} style={{ flex:1, justifyContent:'center' }}>Cancel</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── MAIN ──────────────────────────────────────────────────────────────────
export default function HR() {
  const [tab, setTab] = useState('dashboard');
  const [departments, setDepartments] = useState([]);

  const loadDepts = useCallback(() => {
    fetch(`${API}/departments`).then(r=>r.json()).then(d=>setDepartments(Array.isArray(d)?d:[])).catch(()=>{});
  }, []);
  useEffect(() => { loadDepts(); }, [loadDepts]);

  const tabs = [
    ['dashboard','Dashboard'],['employees','Employees'],['attendance','Attendance'],
    ['leaves','Leaves'],['payroll','Payroll'],['performance','Performance'],
    ['kiosk','Attendance Kiosk'],['import','Bulk Import'],['departments','Departments'],
  ];

  return (
    <div style={{ background:C.bg, minHeight:'100vh' }}>
      <div style={{ background:C.surface, borderBottom:`1px solid ${C.border}`, padding:'0 28px', position:'sticky', top:0, zIndex:50 }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', height:60 }}>
          <div style={{ fontSize:20, fontWeight:800, color:C.text }}>HR Management</div>
          <div style={{ fontSize:12, color:C.text3 }}>{departments.length} departments</div>
        </div>
        <div style={{ display:'flex', gap:2, overflowX:'auto' }}>
          {tabs.map(([id, label]) => (
            <button key={id} onClick={()=>setTab(id)}
              style={{ padding:'10px 16px', border:'none', background:'transparent',
                color: tab===id?C.accent:C.text3, fontSize:13, fontWeight:tab===id?700:500,
                cursor:'pointer', whiteSpace:'nowrap',
                borderBottom: tab===id?`2px solid ${C.accent}`:'2px solid transparent' }}>
              {label}
            </button>
          ))}
        </div>
      </div>
      {tab==='dashboard'   && <Dashboard setTab={setTab} />}
      {tab==='employees'   && <EmployeesTab departments={departments} />}
      {tab==='attendance'  && <AttendanceTab departments={departments} />}
      {tab==='leaves'      && <LeavesTab departments={departments} />}
      {tab==='payroll'     && <PayrollTab />}
      {tab==='performance' && <PerformanceTab />}
      {tab==='kiosk'       && <KioskTab />}
      {tab==='import'      && <BulkImportTab departments={departments} />}
      {tab==='departments' && <DepartmentsTab departments={departments} reload={loadDepts} />}
    </div>
  );
}
